import { Button } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { uploadCertImage } from '../../../../slice/certificateIssuerHomeSlice';

import './ImageDisplay.css';

function ImageDisplay(props) {
  const dispatch = useDispatch();
  const { imageFile, closeUpload, eventId, eventName } = props;

  const [disablebutton, setDisableButton] = useState(false);

  const onUpload = async() => {
    setDisableButton(true);

    const res = (await dispatch(uploadCertImage({ imageFile, eventId }))).payload;
    if (res.ok) {
      closeUpload(true);
    } else {
      setDisableButton(false);
    }
  };

  return (
    <div className='image-display-container'>
      <div className='image-display-event-name'>{eventName}</div>
      <div className='image-display-wrapper'>
        <img src={URL.createObjectURL(imageFile)}/>
      </div>
      <div className='image-display-button-container'>
        <Button backgroundColor='#007bff' color='white' _hover={{ bg: '#0069d9', color: 'whitesmoke' }} margin='20px 100px' text='Upload' onClick={onUpload} disabled={disablebutton}>Upload</Button>
        <Button backgroundColor='#007bff' color='white' _hover={{ bg: '#0069d9', color: 'whitesmoke' }} margin='20px 100px' text='Cancel' onClick={closeUpload} disabled={disablebutton}>Cancel</Button>
      </div>
    </div>
  );
}

ImageDisplay.propTypes = {
  imageFile: PropTypes.object.isRequired,
  closeUpload: PropTypes.func.isRequired,
  eventId: PropTypes.string.isRequired,
  eventName: PropTypes.string.isRequired
};

export default ImageDisplay;
